import { ReactElement, PropsWithChildren } from 'react'
import { Wrapper } from './LayoutContainer.styled'

const LayoutContainer = ({ children }: PropsWithChildren<Record<string, unknown>>): ReactElement => (
  <Wrapper>{children}</Wrapper>
)

export default LayoutContainer
